import { camelizeKeys } from 'humps';
import { schema } from 'normalizr';
import defaults from 'lodash/defaults';
import cloneDeep from 'lodash/cloneDeep';

export const STATUS_WAITLISTED = 'waitlisted';
export const STATUS_RSVP_YES = 'rsvp_yes';
export const STATUS_CHECKIN_YES = 'checkin_yes';
export const STATUS_CHECKIN_NO = 'checkin_no';

export const READABLE_STATUS_WAITLISTED = 'Waitlisted';
export const READABLE_STATUS_RSVP_YES = 'Attending';
export const READABLE_STATUS_CHECKIN_YES = 'Checked In';
export const READABLE_STATUS_CHECKIN_NO = 'Checked Out';

const STATUS_TO_READABLE = {
    [STATUS_WAITLISTED]: READABLE_STATUS_WAITLISTED,
    [STATUS_RSVP_YES]: READABLE_STATUS_RSVP_YES,
    [STATUS_CHECKIN_YES]: READABLE_STATUS_CHECKIN_YES,
    [STATUS_CHECKIN_NO]: READABLE_STATUS_CHECKIN_NO,
};

const READABLE_TO_STATUS = Object.keys(STATUS_TO_READABLE).reduce(
    (obj, status) => ({
        ...obj,
        [STATUS_TO_READABLE[status]]: status,
    }),
    {},
);

/**
 * Default values for a session guest.
 */
export const SESSION_GUEST_DEFAULTS = {
    // todo, not implemented yet
};

export const getReadableStatuses = () =>
    Object.keys(STATUS_TO_READABLE).map((status) => ({
        label: STATUS_TO_READABLE[status],
        value: status,
    }));

export const getLabelFromStatus = (status) => STATUS_TO_READABLE[status];
export const getStatusFromLabel = (label) => READABLE_TO_STATUS[label];

export const processSessionGuest = (sessionGuestData) => {
    const sessionGuest = defaults(camelizeKeys(sessionGuestData), cloneDeep(SESSION_GUEST_DEFAULTS));

    return sessionGuest;
};

export const sessionGuestSchema = new schema.Entity(
    'sessions',
    {},
    {
        processStrategy: (entity) => processSessionGuest(entity),
    },
);

export const sessionGuestsSchema = [sessionGuestSchema];
